import ITipoDeEmancipacao from '../../interfaces/ITipoDeEmancipacao';
import ITipoDeEmancipacaoParaSelect from '../../interfaces/ITipoDeEmancipacaoParaSelect';

export const mapearTipoDeEmancipacaoParaSelect = (tiposDeEmancipacao: ITipoDeEmancipacao[]): ITipoDeEmancipacaoParaSelect[] =>
  tiposDeEmancipacao.map(({ id, descricao: nome }) => ({
    value: id,
    label: nome
  }));